import { useState, useEffect } from "react";
import styled from "styled-components";
import { Col, Row } from "react-grid-system";
import { AiFillDelete, AiFillEdit } from "react-icons/ai";

import toast, { Toaster } from "react-hot-toast";

import { CgArrowsVAlt } from "react-icons/cg";

import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

import { getDatabase, ref, update, set } from "firebase/database";

const reorder = (list, startIndex, endIndex) => {
  const result = [...list];
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

export default function OrderListItems(props) {
  const { items } = props;
  const [liststate, setListState] = useState([]);
  const [change, setChanges] = useState(false);
  const [isLoader, setLoader] = useState(false);

  useEffect(() => {
    let newItems = [];
    let pos = 0;
    items.map((i) => {
      if (!i.positons) {
        newItems.push({
          ...i,
          position: ++pos,
        });
      } else {
        newItems.push({ ...i });
      }
    });
    setListState(newItems);
  }, [props]);

  // functions drag
  const changeDrag = (param) => {
    const srcI = param.source?.index;
    const dropId = param.source?.droppableId;
    const desI = param.destination?.index;
    const dropDes = param.destination?.droppableId;

    if (srcI === desI && dropId === dropDes) return;

    setListState((prevTasks) => reorder(prevTasks, srcI, desI));
    setChanges(true);
  };

  const saveNewData = async () => {
    const db = getDatabase();

    setLoader(true);
    const list = [...liststate];
    let new_list = [];

    list.map((lt, index) => {
      let object = { ...lt, position: index };
      new_list.push(object);
    });

    const id_restaurant = props.data.id_restaurant;
    const id_section = props.data.id;

    try {
      const dbDirection = `/restaurants/${id_restaurant}/menu/${id_section}/items/`;
      const updates = {};
      updates[dbDirection] = new_list;

      update(ref(db), updates);

      toast.success("Posiciones de las items modificadas correctamente.");
      setChanges(false);
      setLoader(false);
    } catch (error) {
      toast.error("Error al editar los items.😬");
      setLoader(false);
    }
  };

  return (
    <>
      {liststate.length > 0 && (
        <DragDropContext onDragEnd={(param) => changeDrag(param)}>
          <Droppable droppableId="droppable-1" id="droppable-1">
            {(provided, snapshot) => (
              <div ref={provided.innerRef} {...provided.droppableProps}>
                {liststate.map((data, i) => (
                  <Draggable
                    key={data.position}
                    draggableId={`draggable-${data.position}`}
                    index={i}
                  >
                    {(provided, snapshot) => (
                      <ListItem
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        style={{
                          ...provided.draggableProps.style,
                          boxShadow: snapshot.isDragging
                            ? "0px 0px 10px #a8a8a847"
                            : "none",
                        }}
                      >
                        <Row>
                          <Col xs={2}>
                            <span>
                              <CgArrowsVAlt />
                            </span>
                          </Col>
                          <Col xs={2}>
                            <img
                              src={
                                data.image ||
                                "https://i.postimg.cc/MpKmf60L/descargar.jpg"
                              }
                              alt=""
                            />
                          </Col>
                          <Col xs={4}>
                            <h5> {data.name} </h5>
                          </Col>
                          <Col xs={2}>${data.price}</Col>
                          <Col xs={2}>
                            <button
                              className="btn btn-secondary text-dark"
                              onClick={() => props.handleEdit(data)}
                            >
                              <AiFillEdit style={{ fontSize: "1.4em" }} />
                            </button>
                            <button
                              className="btn btn-secondary text-danger d-block"
                              onClick={() => props.handleDelete(data)}
                            >
                              <AiFillDelete
                                style={{ fontSize: "1.4em" }}
                                onClick={() => props.handleDelete(data)}
                              />
                            </button>
                          </Col>
                        </Row>
                      </ListItem>
                    )}
                  </Draggable>
                ))}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      )}
      {liststate.length > 0 && (
        <>
          {change && (
            <div className="w-100 my-4 text-center">
              {" "}
              <div className="row align-items-center justify-content-center">
                <div className="col-6">
                  <button
                    className="btn btn-success d-block w-100"
                    onClick={() => saveNewData()}
                  >
                    Guardar cambios
                  </button>
                </div>
              </div>
            </div>
          )}
        </>
      )}
      <Toaster position="bottom-center" reverseOrder={false} />
    </>
  );
}

const ListItem = styled.div`
  width: 100%;
  border-bottom: 1px solid #a8a8a839;
  padding: 1.5em 1em;
  background: white;
  border-radius: 5px;
  font-size: 1.2em;
  img {
    width: 50px;
  }
  p {
    font-size: 16px;
  }
  svg {
    font-size: 1.2em;
    margin-right: 0.2em;
  }
`;
